<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "PublicRoutesName",
};
</script>

<style></style>
